<div class="task">
  @if (task !== null) {
    <div class="task__container">
      <lib-task-header-info [task]="task" [taskTypeAction]="taskTypeAction" [recentTaskNote]="recentTaskNote">
      </lib-task-header-info>
      @if (taskTypeAction !== null) {
        <div class="task-link__content">
        @switch (this.taskTypeAction?.formType) {
          @case (1) {
            <lib-home-school-registration-information
              [task]="task"
              [taskAction]="taskAction"
              [taskTypeAction]="taskTypeAction"
              (submitFormData)="updateTask($event)">
            </lib-home-school-registration-information>
          }
          @case (2) {
            <lib-school-transfer-and-withdrawal-form
              [task]="task"
              [taskAction]="taskAction"
              [taskTypeAction]="taskTypeAction"
              (submitFormData)="updateTask($event)">
            </lib-school-transfer-and-withdrawal-form>
          }
          @case (3) {
            <lib-enrollment-verification-form
              [task]="task"
              [taskAction]="taskAction"
              [taskTypeAction]="taskTypeAction"
              (submitFormData)="updateTask($event)">
            </lib-enrollment-verification-form>
          }
          @case (4) {
            <lib-award-endorsement-form
              [task]="task"
              [taskAction]="taskAction"
              [taskTypeAction]="taskTypeAction"
              [programType]="ProgramType.OS"
              (submitFormData)="updateTask($event)">
            </lib-award-endorsement-form>
          }
          @case (5) {
            <lib-award-acceptance-form
              [task]="task"
              [taskAction]="taskAction"
              [taskTypeAction]="taskTypeAction"
              (submitFormData)="updateTask($event)">
            </lib-award-acceptance-form>
          }
          @case (6) {
            <lib-lea-release-form
              [task]="task"
              [taskAction]="taskAction"
              [taskTypeAction]="taskTypeAction"
              (submitFormData)="updateTask($event)">
            </lib-lea-release-form>
          }
          @case (7) {
            <lib-award-endorsement-form
              [task]="task"
              [taskAction]="taskAction"
              [taskTypeAction]="taskTypeAction"
              [programType]="ProgramType.ESA"
              (submitFormData)="updateTask($event)">
            </lib-award-endorsement-form>
          }
          @case (8) {
            <lib-income-verification-form
              [task]="task"
              [taskAction]="taskAction"
              [taskTypeAction]="taskTypeAction"
              (submitFormData)="updateTask($event)">
            </lib-income-verification-form>
          }
          @case (9) {
            <lib-verification-of-non-filing-form
              [task]="task"
              [taskAction]="taskAction"
              [taskTypeAction]="taskTypeAction"
              (submitFormData)="updateTask($event)">

            </lib-verification-of-non-filing-form>
          }
          @case (10) {
            <lib-guardian-change-form
              [task]="task"
              [taskAction]="taskAction"
              [taskTypeAction]="taskTypeAction"
              (submitFormData)="updateTask($event)">

            </lib-guardian-change-form>
          }
          @case (11) {
            <lib-household-transfer-withdrawal-form
              [task]="task"
              [taskAction]="taskAction"
              [taskTypeAction]="taskTypeAction"
              [askIfCurrentlyAttending]="false"
              (submitFormData)="updateTask($event)">
            </lib-household-transfer-withdrawal-form>
          }
          @case (12) {
            <lib-school-cost-correction-form
              [task]="task"
              [taskAction]="taskAction"
              [taskTypeAction]="taskTypeAction"
              (submitFormData)="updateTask($event)">
            </lib-school-cost-correction-form>
          }
          @case (13) {
            <lib-award-endorsement-task-form
              [task]="task"
              [taskAction]="taskAction"
              [taskTypeAction]="taskTypeAction"
              (submitFormData)="updateTask($event)">
            </lib-award-endorsement-task-form>
          }
          @default {
            <h3>Unsupported Form Type</h3>
          }
        }
        </div>
      }
    </div>
  }
</div>
